export default "__VITE_ASSET__CJoXnYkj__"